import React, {useState} from 'react';
import Grid from '@mui/material/Grid2';
import {useTranslation} from "react-i18next";
import axios from "axios";
import {defaultVariables} from "../../../../../config";
import GetConfirmationButton from "../../../../components/elements/GetConfirmationButton";
import {Card, Switch, Typography} from "@mui/material";
import {CheckBoxRounded} from "@mui/icons-material";
import {withStyles} from "@mui/styles";
import {Styles} from "../../../../../config/design/styles";
import Box from '@mui/material/Box';
import {
    Trash,
    TicketPercent,
    SquareX,
    SquareCheckBig,
    MessageCircleMore,
    Star,
    UserRound,
    Store,
    ChevronRight
} from "lucide-react";
import MakeCommentButtonManage from "../MakeCommentButtonManage";
import Button from "@mui/material/Button";
import {Link} from "react-router-dom";
import {getDisplayDate, truncate} from "../../../../../config/values";

function CommentCard({classes,item,reload}){
    const { t } = useTranslation();
    const loginToken = localStorage.getItem('ACT');
    const [loading, setLoading] = useState(false);

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`
        }
    }
    const handleDelete = (item_id) =>{
        setLoading(true);
        let data = new FormData();
        data.append('id', item_id);
        axios.post(`${defaultVariables.url}/comments/delete`,data,config)
            .then(response => {
                setLoading(false);
                reload();

            })
            .catch(error => {
                console.error("Error fetching item data:", error);
                setLoading(false);
            });
    }
    const handleActive = (item_id) =>{

        let data = new FormData();
        data.append('id', item_id);
        axios.post(`${defaultVariables.url}/comments/toggle-active`,data,config)
            .then(response => {
                reload();
            })
            .catch(error => {
                console.error("Error fetching item data:", error);

            });
    }
    return (
        <Card className="item-card bg-card">
            <Grid container spacing={2}>
                <Grid item size={12}>
                    <Box className={classes.categoryHold}>
                        <div className="details">
                            <div className="name-holder">
                                <Typography>
                                    {
                                        !!item.confirmed ?
                                            <Typography className="table-badge absolute-badge active">{t('confirmed')}</Typography>
                                            :
                                            <Typography className="table-badge absolute-badge inactive">{t('pending')}</Typography>
                                    }
                                </Typography>
                            </div>
                            <div className='rating-holder rating-vendor'>
                                <div className="date-box star-comment">
                                    <span >{getDisplayDate(item.created_at)}</span>
                                </div>
                                <span className="flex-direction ml-10" style={{gap:0, fontSize:14}}>
                                        <Star className="rating-icon" style={{marginRight:3}} />
                                    {item.rate}
                                </span>
                            </div>
                        </div>
                    </Box>
                    <div className="my-15 bg-red-box">
                        <span>{truncate(item.comment,70)}</span>
                    </div>
                    {
                        !!item.user &&
                        <div className="flex-direction mb-5">
                            <UserRound className="lucide-small-narrow" />
                            <Link to={`/panel/manage/users/edit/${item.user?.id}`}>{item.user?.first_name} {item.user?.last_name}</Link>
                            <ChevronRight  className="lucide-small-narrow"/>
                        </div>
                    }

                    {
                        !!item.shop &&
                        <div className="flex-direction mb-5">
                            <Store className="lucide-small-narrow" />
                            <Link to={`/panel/manage/shops/edit/${item.shop?.id}`}>{item.shop?.name}</Link>
                            <ChevronRight  className="lucide-small-narrow"/>
                        </div>
                    }

                    <div className="comment-products my-15">
                        {
                            item.products?.slice(0, 2).map((product, index) => (
                                <span key={index}>
                                    <Link to={`/panel/manage/products/edit/${product.id}`}>
                                      {truncate(product?.name, 10)}
                                    </Link>
                                  </span>
                            ))
                        }
                        {
                            item.products?.length > 2 && (
                                <p>+{item.products.length - 2}</p>
                            )
                        }
                    </div>

                    <div>
                        <div className="actions actions-gap action-holder p-less">
                            <div className="flex-direction" style={{gap: 3}} >
                                <GetConfirmationButton
                                    handleAction={() => handleDelete(item.id)}
                                    question={t('doYouWanaDeleteItem')}
                                    icon={<CheckBoxRounded/>}
                                    tooltip={t('delete')}
                                    loading={loading}
                                    iconColor="primary"
                                >
                                    <Trash className="lucide-icon-primary btn"/>
                                </GetConfirmationButton>
                                <Switch
                                    size="small"
                                    checked={item.confirmed}
                                    onChange={() => handleActive(item.id)}
                                    color="secondary"
                                />
                            </div>
                            <MakeCommentButtonManage item_id={item.id} reload={reload} item={item}/>
                        </div>
                    </div>


                </Grid>
            </Grid>
        </Card>
    );
}
export default withStyles(Styles)(CommentCard);
